import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../utils.esm.js';

const EntityTagsPickerFieldSchema = makeFieldSchemaFromZod(
  z.array(z.string()),
  z.object({
    kinds: z.array(z.string()).optional().describe("List of kinds of entities to derive tags from"),
    showCounts: z.boolean().optional().describe("Whether to show usage counts per tag"),
    helperText: z.string().optional().describe("Helper text to display")
  })
);
const EntityTagsPickerSchema = EntityTagsPickerFieldSchema.schema;

export { EntityTagsPickerFieldSchema, EntityTagsPickerSchema };
//# sourceMappingURL=schema.esm.js.map
